<template>
  <div class="pt-4">
    <div class="row mb-4" v-if="heading">
      <div class="col-12 text-center">
        <h3 class="font-weight-bolder">{{heading}}</h3>
      </div>
    </div>
    <div class="row mb-4 policy">
      <div class="col-12">
        <div v-html="content"></div>
      </div>
    </div>
    <LoaderGif :disable="loading" :success="success" :message="message" />
  </div>
</template>

<script>
import axios from "axios";
import { domain } from "@/store/variable";
import LoaderGif from "./LoaderGif.vue";

export default {
  name: "policyDetail",
  components: {
    LoaderGif
  },

  data() {
    return {
      heading: null,
      content: null,
      loading: false,
      success: false,
      message: null
    };
  },

  beforeRouteEnter(to, from, next) {
    let url = domain + "aboutUs";
    axios
      .get(url, {
        params: {
          name: to.params.name
        }
      })
      .then(res => {
        res.data.forEach(doc => {
          next(vm => {
            if (to.params.name == "termsandcondition") {
              vm.heading = "Terms and Conditions";
            } else if (to.params.name == "privacypolicy") {
              vm.heading = "Privacy Policy";
            } else if (to.params.name == "aboutus") {
              vm.heading = "About US";
            } else if (to.params.name == "applicense") {
              vm.heading = "License";
            } else if (to.params.name == "delivery") {
              vm.heading = null;
            }
            vm.content = doc;
          });
        });
      })
      .catch(err => {
        console.log(err.message);
      });
  },

  watch: {
    $route: "fetchContent"
  },

  methods: {
    fetchContent() {
      this.loading = true;
      if (this.$route.params.name == "termsandcondition") {
        this.heading = "Terms and Conditions";
      } else if (this.$route.params.name == "privacypolicy") {
        this.heading = "Privacy Policy";
      } else if (this.$route.params.name == "returnpolicy") {
        this.heading = "Return and Refund Policy";
      } else if (this.$route.params.name == "aboutus") {
        this.heading = "About US";
      } else if (this.$route.params.name == "applicense") {
        this.heading = "License";
      } else if (this.$route.params.name == "delivery") {
        this.heading = null;
      }

      let url = domain + "aboutUs";
      axios
        .get(url, {
          params: {
            name: this.$route.params.name
          }
        })
        .then(res => {
          res.data.forEach(doc => {
            this.content = doc;
            this.loading = false;
          });
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.policy {
  height: 60vh;
  overflow: auto;
}

.aboutUs h1,
.aboutUs h2,
.aboutUs h3,
.aboutUs h4,
.aboutUs h5,
.aboutUs h6 {
  font-size: 1.1 rem;
  font-weight: normal;
  color: #2c211e;
}

.aboutUs strong {
  color: #2c211e;
}

.aboutUs {
  font-family: "Poppins";
  font-size: 1 rem;
  line-height: 1 em;
  color: #606c71;
}
</style>



// WEBPACK FOOTER //
// src/components/policy.vue